document.addEventListener('click', function (e) {
  const btn = e.target.closest('.imswatch');
  if (!btn) return;

  const wrap = btn.closest('.imswatches');
  const value = (btn.dataset.optionValue || '').trim();
  const section = btn.closest('section') || document;

  // Find a label for Dawn's picker whose text STARTS with our value
  const labels = Array.from(section.querySelectorAll('label[for]'));
  const targetLabel = labels.find(l => {
    const txt = (l.textContent || '').trim().toLowerCase();
    return txt.startsWith(value.toLowerCase());
  });

  if (targetLabel) {
    // Prefer clicking the associated input if present, else click the label
    const inputId = targetLabel.getAttribute('for');
    const input = inputId ? section.querySelector(`#${CSS.escape(inputId)}`) : null;
    (input || targetLabel).click(); // triggers Dawn’s built-in switching
  }

  // Visual active state for our custom pills
  wrap.querySelectorAll('.imswatch').forEach(b => {
    const active = b === btn;
    b.classList.toggle('is-active', active);
    b.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
});
// Re-hide Dawn's native Color group whenever the DOM changes or a variant changes
function hideNativeColorGroup(root) {
  const scope = root || document;

  // Only if our custom swatches are on the page
  if (!scope.querySelector('.imswatches')) return;

  scope.querySelectorAll('fieldset.product-form__input').forEach(fs => {
    const legend = fs.querySelector('legend');
    if (!legend) return;
    const txt = (legend.textContent || '').trim().toLowerCase();
    if (txt.startsWith('color')) {
      fs.style.display = 'none';
    }
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', () => hideNativeColorGroup(document));

// Run when Theme Editor reloads a section
document.addEventListener('shopify:section:load', (e) => hideNativeColorGroup(e.target));

// Run when a native option changes (e.g., clicking Size or Color)
document.addEventListener('change', (e) => {
  if (e.target && e.target.name && e.target.name.startsWith('options[')) {
    hideNativeColorGroup(document);
  }
});

// Run when our custom swatch is clicked
document.addEventListener('click', (e) => {
  if (e.target.closest('.imswatch')) {
    // give Dawn a beat to update the DOM, then hide again
    setTimeout(() => hideNativeColorGroup(document), 0);
  }
});

// As a safety net, watch for DOM changes and re-apply the hide
const mo = new MutationObserver(() => hideNativeColorGroup(document));
mo.observe(document.documentElement, { childList: true, subtree: true });

